import icons from './icons';

export default [
  { title: 'Angular@1.x', rating: 8, icon: icons.angular },
  { title: 'Chrome Ext.', rating: 7, icon: icons.chrome },
  { title: 'Creative Suite', rating: 7, icon: icons.adobe },
  { title: 'CSS', rating: 9, icon: icons.css },
  { title: 'Firebase', rating: 4.5, icon: icons.fire },
  { title: 'Git', rating: 8.25, icon: icons.git },
  { title: 'HTML', rating: 9.5, icon: icons.html },
  { title: 'Node', rating: 7, icon: icons.node },
  { title: 'Rails', rating: 5.5, icon: icons.rails },
  { title: 'React', rating: 8.5, icon: icons.react },
  { title: 'Redux', rating: 7.5, icon: icons.redux },
  { title: 'Redux-Saga', rating: 6.5, icon: icons.saga },
  { title: 'Ruby', rating: 5.5, icon: icons.ruby },
  { title: 'SASS', rating: 8, icon: icons.sass },
  { title: 'WordPress', rating: 8, icon: icons.wordpress },
];



// WEBPACK FOOTER //
// ./src/data/skills.js